export type BaseMapValue =
  | "google_roadmap"
  | "osm"
  | "hot"
  | "dark"
  | "cycle"
  | "google_traffic"
  | "google_satellite"
  | "google_terrain"
  | "apple"
  | "apple_satellite"
  | "apple_hybrid";

export type AppleBaseMapValue = "apple" | "apple_satellite" | "apple_hybrid";
export type AppleMapType = "standard" | "satellite" | "hybrid";
export type BaseMapToolKey = "map" | "fleet" | "poi" | "geofence" | "modal";

export type BaseMapOption = {
  value: BaseMapValue;
  label: string;
  icon: string;
};

export type BaseMapGroup = {
  label: string;
  options: BaseMapOption[];
};

export type BaseMapToolOption = {
  key: BaseMapToolKey;
  label: string;
  description: string;
};

export const BASE_MAP_OPTIONS: BaseMapOption[] = [
  {
    value: "google_roadmap",
    label: "Google Roadmap",
    icon: "http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}",
  },
  {
    value: "osm",
    label: "OpenStreetMap",
    icon: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  },
  {
    value: "hot",
    label: "Humanitarian",
    icon: "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
  },
  {
    value: "dark",
    label: "Dark",
    icon: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}@2x.png",
  },
  {
    value: "cycle",
    label: "Cycle",
    icon: "https://dev.{s}.tile.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png",
  },
  {
    value: "google_traffic",
    label: "Google Traffic",
    icon: "https://mt0.google.com/vt?lyrs=h@221097413,traffic&x={x}&y={y}&z={z}",
  },
  {
    value: "google_satellite",
    label: "Google Satellite",
    icon: "https://www.google.com/maps/vt?lyrs=s@189&gl=us&x={x}&y={y}&z={z}",
  },
  {
    value: "google_terrain",
    label: "Google Terrain",
    icon: "https://www.google.com/maps/vt?lyrs=p@189&gl=us&x={x}&y={y}&z={z}",
  },
  {
    value: "apple",
    label: "Apple Maps",
    icon: "",
  },
  {
    value: "apple_satellite",
    label: "Apple Satellite",
    icon: "",
  },
  {
    value: "apple_hybrid",
    label: "Apple Hybrid",
    icon: "",
  },
];

export const BASE_MAP_URLS: Record<BaseMapValue, string> = Object.fromEntries(
  BASE_MAP_OPTIONS.map((option) => [option.value, option.icon])
) as Record<BaseMapValue, string>;

export const APPLE_BASE_MAP_VALUES: AppleBaseMapValue[] = [
  "apple",
  "apple_satellite",
  "apple_hybrid",
];

export const BASE_MAP_GROUPS: BaseMapGroup[] = [
  {
    label: "Google",
    options: BASE_MAP_OPTIONS.filter((option) =>
      [
        "google_roadmap",
        "google_traffic",
        "google_satellite",
        "google_terrain",
      ].includes(option.value)
    ),
  },
  {
    label: "OpenStreetMap",
    options: BASE_MAP_OPTIONS.filter((option) =>
      ["osm", "hot", "cycle"].includes(option.value)
    ),
  },
  {
    label: "Apple",
    options: BASE_MAP_OPTIONS.filter((option) =>
      ["apple", "apple_satellite", "apple_hybrid"].includes(option.value)
    ),
  },
  {
    label: "Autres",
    options: BASE_MAP_OPTIONS.filter((option) => option.value === "dark"),
  },
];

export const BASE_MAP_TOOL_OPTIONS: BaseMapToolOption[] = [
  {
    key: "map",
    label: "Carte principale",
    description: "Carte temps reel et suivi general.",
  },
  {
    key: "fleet",
    label: "Flotte",
    description: "Drawer Position du Vehicule dans la flotte.",
  },
  {
    key: "poi",
    label: "Points d'interet",
    description: "Creation et modification des zones POI.",
  },
  {
    key: "geofence",
    label: "Geofence checker",
    description: "Verification et dessin des geofences.",
  },
  {
    key: "modal",
    label: "Modales carte",
    description: "Cartes rapides ouvertes depuis les outils.",
  },
];

export function isAppleBaseMap(value: string): value is AppleBaseMapValue {
  return APPLE_BASE_MAP_VALUES.includes(value as AppleBaseMapValue);
}

export function getAppleMapType(value: AppleBaseMapValue): AppleMapType {
  switch (value) {
    case "apple_satellite":
      return "satellite";
    case "apple_hybrid":
      return "hybrid";
    case "apple":
    default:
      return "standard";
  }
}
